import { render, staticRenderFns } from "./ExchangeProductSlotPanel.vue?vue&type=template&id=6a98433c&"
import script from "./ExchangeProductSlotPanel.vue?vue&type=script&lang=ts&"
export * from "./ExchangeProductSlotPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ExchangeProductSlotPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports